import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { ForgeTooltip } from '@tylertech/forge-react';

const CustomTooltip = ({ value, eParentOfValue }) => {
  const tooltipRef = useRef(null);

  return (
    <ForgeTooltip
      ref={tooltipRef}
      anchor={eParentOfValue}
      open
      placement="bottom"
      style={{ pointerEvents: 'none' }}
    >
      {value}
    </ForgeTooltip>
  );
};

CustomTooltip.propTypes = {
  value: PropTypes.any,
  eParentOfValue: PropTypes.any
};

export default CustomTooltip;
